import { fork, put, call } from 'redux-saga/effects'
import { takeLatestAndCancel } from './effects/take'

import * as api from '../../api'
import {

  SET_SELECTED_COUNTRY,
  LOAD_COUNTRY_DATA,
  LOAD_COUNTRY_DATA_UNLOAD,
  LOAD_COUNTRY_DATA_LOADING,
  LOAD_COUNTRY_DATA_SUCCESS,
  LOAD_COUNTRY_DATA_ERROR,

  SET_COMPARISON_COUNTRY,
  LOAD_COMPARISON_COUNTRY_DATA,
  LOAD_COMPARISON_COUNTRY_DATA_UNLOAD,
  LOAD_COMPARISON_COUNTRY_DATA_LOADING,
  LOAD_COMPARISON_COUNTRY_DATA_SUCCESS,
  LOAD_COMPARISON_COUNTRY_DATA_ERROR,

  COUNTRY_FACILITATION,
  THIRD_PILLAR,
  SEVEN_PILLARS,
  TFA_ARTICLES,
  TFA_PROVISIONS,
  LATEST_BY_INDICATOR,



} from '../actions'

function *handleLoadCountryData({ payload }) {
  yield put({ type: LOAD_COUNTRY_DATA_LOADING })
  try {
    const data = yield call(api.getJsonData, `/by_country/${payload.toLowerCase()}.json`)
    yield put({ type: LOAD_COUNTRY_DATA_SUCCESS, payload: data })
  } catch (error) {
    yield put({ type: LOAD_COUNTRY_DATA_ERROR, error })
  }
}

function *handleLoadComparisonCountryData({ payload }) {
  yield put({ type: LOAD_COMPARISON_COUNTRY_DATA_LOADING })
  try {
    const data = yield call(api.getJsonData, `/by_country/${payload.toLowerCase()}.json`)
    yield put({ type: LOAD_COMPARISON_COUNTRY_DATA_SUCCESS, payload: data })
  } catch (error) {
    yield put({ type: LOAD_COMPARISON_COUNTRY_DATA_ERROR, error })
  }
}

const makePageSaga = (prefix, filename) => {

  function *handlePageLoad({ payload }) {
    yield put({ type: `${prefix}_LOADING` })
    try {
      const data = yield call(api.getJsonData, filename)
      yield put({ type: `${prefix}_SUCCESS`, payload: data })
    } catch (error) {
      yield put({ type:`${prefix}_ERROR`, error })
    }
  }

  return function* (){
    yield fork(
      takeLatestAndCancel,
      `${prefix}`,
      `${prefix}_UNLOAD`,
      handlePageLoad
    )
  }
}


export default function* rootSaga() {
  yield fork(
    takeLatestAndCancel,
    SET_SELECTED_COUNTRY,
    LOAD_COUNTRY_DATA_UNLOAD,
    handleLoadCountryData,
  )

  yield fork(
    takeLatestAndCancel,
    SET_COMPARISON_COUNTRY,
    LOAD_COMPARISON_COUNTRY_DATA_UNLOAD,
    handleLoadComparisonCountryData,
  )

  yield fork(makePageSaga(COUNTRY_FACILITATION, '/by_indicator/eti.json'))
  yield fork(makePageSaga(SEVEN_PILLARS, '/by_indicator/eti.json'))
  yield fork(makePageSaga(THIRD_PILLAR, '/by_indicator/etib03.json'))
  yield fork(makePageSaga(TFA_ARTICLES, '/tfa/data_tfa_articles.json'))
  yield fork(makePageSaga(TFA_PROVISIONS, '/tfa/data_tfa_provisions.json'))
  yield fork(makePageSaga(LATEST_BY_INDICATOR, '/latest_by_indicator.json'))


}



// WEBPACK FOOTER //
// ./src/state/saga/index.js